import { ListQueryProps } from '../Select'
import { Button } from '../../../Button'

type Props = {
  listQueryProps: ListQueryProps
}

export const LoadMoreSelections = ({ listQueryProps }: Props) => {
  const { loading, fetchNextPage, isFetching, canFetchNextPage, take, count } =
    listQueryProps

  if (!canFetchNextPage) return null
  return (
    <div className='p-4'>
      <Button
        loading={loading || isFetching}
        type='button'
        onClick={fetchNextPage}
        className='min-w-fit'>
        Load More Data
      </Button>
    </div>
  )
}
